export enum AccessRole {
  SUPER_ADMIN = 'SUPER_ADMIN',
  ADMIN = 'ADMIN',
  SALES = 'SALES',
  SUPPORT = 'SUPPORT',
  DEVELOPER = 'DEVELOPER',
  CMS_SUPERVISOR = 'CMS_SUPERVISOR',
  DEFAULT = 'DEFAULT',
}

export const ALL_ACCESS_ROLES: AccessRole[] = Object.values(AccessRole)

/**
 * Access role categories used to decide who can manage another user's Access Departments.
 * Mirrors the backend AccessRoleCategory used in validateUpdateAdminDepartments.
 */
export enum AccessRoleCategory {
  SUPER_ADMIN = 'SUPER_ADMIN',
  ADMIN = 'ADMIN',
  NON_ADMIN = 'NON_ADMIN',
}

const parseAccessRoles = (accessRoles: string | null | undefined): string[] =>
  (accessRoles ?? '')
    .split(',')
    .map((role) => role.trim().toUpperCase())
    .filter((role) => role !== '')

export const resolveAccessRoleCategory = (
  accessRoles: string | null | undefined,
): AccessRoleCategory => {
  const roles = parseAccessRoles(accessRoles)

  if (roles.includes(AccessRole.SUPER_ADMIN)) {
    return AccessRoleCategory.SUPER_ADMIN
  }

  if (roles.includes(AccessRole.ADMIN)) {
    return AccessRoleCategory.ADMIN
  }

  return AccessRoleCategory.NON_ADMIN
}

export const hasAccessRole = (accessRoles: string | null | undefined, role: AccessRole): boolean =>
  parseAccessRoles(accessRoles).includes(role)
